// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1G0B3","rootSuccess":"CompleteLink_rootSuccess__3TglD","rootFailure":"CompleteLink_rootFailure__1OTf4","isDisabled":"CompleteLink_isDisabled__1mZTu"};